module.exports = __webpack_public_path__ + "static/media/17230022-jWg1wSgs.428337ca.JPG";